import AirDatepicker from 'air-datepicker';
import localeEN from 'air-datepicker/locale/en';
import localeFR from 'air-datepicker/locale/fr';
import localeDE from 'air-datepicker/locale/de';

export default class IADatepicker {
    /**
     * @param {String | HTMLElement} element HTML element or CSS class which initialize Air Datepicker
     * @param {Object} [options] Object of Air Datepicker options (https://air-datepicker.com/docs)
     * @param {String} [options.locale] Set Air Datepicker language code to use
     * @param {Boolean} [options.inline=false] Makes the calendar to be permanently visible
     * @param {Date|String} [options.startDate] Sets the start view date of calendar
     * @param {Number} [options.firstDay] Makes the calendar to be permanently visible
     * @param {Numer[]} [options.weekends] Indexes of the days that will be considered a weekend. The .-weekend- class will be added to them. By default, this is Saturday and Sunday.
     * @param {Boolean} [options.isMobile] If true, then the calendar will appear as a modal window with slightly enlarged dimensions.
     * @param {Boolean} [options.visible] Shows the calendar immediately after initialization.
     * @param {String} [options.dateFormat] Date format. Since version 3, the date format is based on the Unicode Technical Standard #35 standard. By default, it is taken from the current locale. The value passed here will have a higher priority.
     */
    constructor(element, options = { locale: 'en' }) {
        switch(options.locale) {
            case 'de':
                options.locale = localeDE
            break
            case 'fr':
                options.locale = localeFR
            break
            case 'en':
            default:
                options.locale = localeEN
            break;
        }
        this.instance = new AirDatepicker(element, options)
    }
}